export enum SaveTypes {
  Save = 1,
  Complete = 2,
  UpdateWithoutTicketNoteValidation = 3, // Used for Resetting Customer Website from SEO Onboarding
  Reject = 4
}